import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationTaxesActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Taxes/TaxesBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationTaxes"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationTaxes"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationTaxesActivity)
